import {useQuery} from '@apollo/react-hooks';

import type {GetMarketingDashboardChecklist as GetMarketingDashboardQuery} from 'nutshell-graphql-types';

import GET_MARKETING_DASHBOARD_CHECKLIST from '../queries/get-marketing-dashboard-checklist.graphql';

export const useGetMarketingDashboardChecklist = () => {
    const {
        data,
        loading: isLoading,
        refetch,
    } = useQuery<GetMarketingDashboardQuery, Record<any, any>>(GET_MARKETING_DASHBOARD_CHECKLIST, {
        fetchPolicy: 'cache-and-network',
    });

    const marketingDashboardChecklist = data ? data.marketingDashboardChecklist : null;
    const completedCount = marketingDashboardChecklist
        ? marketingDashboardChecklist.items.filter((item) => item.isComplete).length
        : undefined;
    const totalCount = marketingDashboardChecklist
        ? marketingDashboardChecklist.items.length
        : undefined;
    const checklistIsComplete = totalCount && completedCount === totalCount;

    return {
        marketingDashboardChecklist,
        completedCount,
        totalCount,
        checklistIsComplete,
        isLoading,
        refetch,
    };
};
